import { cn } from '@utils/style-utils'

import { Skeleton } from 'components/core/skeleton'

const skeletonCellRenderer = ({ heightClass = 'h-full' }: { heightClass: string }) => (
  <Skeleton className={cn('w-full', heightClass)} />
)

export default skeletonCellRenderer
